export default {
  "Loop as a GIF": "無限ループ再生(GIF)",
  "without sound": "音声なし",
  "Final output duration": "最終出力時間",
};
